/* eslint-disable react/jsx-key */
// Station
import React, { useState } from 'react'
import { numCol, intCol } from '@integec/grid-tools/lib/cols'
import {
  modifierCol,
  modifiedDateCol,
  utilityHeader,
  unitIdHeader,
} from 'core/HeaderColTypeProps'
import {
  getApiTargetInfo,
  getEnvConfig,
  getPermitActions,
  getUtilityNameMap,
  getUnitNameMap,
  UtilityUnitSelection,
} from 'core'
import { connect } from 'react-redux'
import {
  performanceOverideReport,
  performanceOverideReportSave,
  performanceOverideReportDelete,
} from 'api/pgads.js'
import { Button, Select, InputNumber } from 'antd'
import styled from 'styled-components'
import * as ScreenPermissions from 'core/EventActions'
import { hasAccesPermits, months, monthsMap } from 'core/utils'
import CommonScreen from 'admin/component/CommonScreen'
import moment from 'moment'
import R from 'ramda'
import { toSelectionColProps } from '@integec/grid-tools/lib/utils'
const TableTD = styled.td`
  text-align: end;
`

const headers = [
  utilityHeader,
  unitIdHeader,
  intCol({ ident: 'year', display: 'Year', isKey: true, sortOrder: 'asc' }),
  intCol({
    ident: 'month',
    display: 'Month',
    isKey: true,
    sortOrder: 'asc',
    ...toSelectionColProps(monthsMap),
  }),
  numCol({
    ident: 'attStarts',
    display: 'Att Starts',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({ ident: 'succStarts', display: 'Succ Starts', isFiltered: true }),
  numCol({ ident: 'allT1T2', display: 'All T1 T2', isFiltered: true }),
  numCol({ ident: 'hour24T1T2', display: 'Hour24 T1 T2', isFiltered: true }),
  modifierCol,
  modifiedDateCol,
]

const retrieveTask = apiTargetInfo => performanceOverideReport(apiTargetInfo)

const modifyTask = apiTargetInfo => data =>
  performanceOverideReportSave(apiTargetInfo)(data)

const deleteTask = apiTargetInfo => data =>
  performanceOverideReportDelete(apiTargetInfo)(data)

const title = 'Performance Measures Override'

const curYear = parseInt(moment().format('YYYY'))

const PerfOverided = ({ unitNameMap, utilityNameMap, ...props }) => {
  const [insertEvent, setInsertEvent] = useState(false)
  const { authGodMode } = props.envConfig
  const actionPermits = props.actionPermits

  const writePermision = hasAccesPermits({
    authGodMode,
    actionPermits,
    eventActions: [ScreenPermissions.REPORT_PERFORMANCE_MEASURES_ADMIN],
    matchAny: true,
  })

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    return (
      <table
        style={{
          width: '100%',
          borderSpacing: '5px',
          borderCollapse: 'inherit',
        }}
      >
        <tbody>
          <tr>
            <TableTD>Utility / Unit :</TableTD>
            <td style={{ minWidth: '150px' }} colSpan={3}>
              <UtilityUnitSelection
                utility={insertData.utility}
                unit={insertData.unit}
                onUnitChange={value => {
                  // setUtilityUnit(value)
                  setInsertData({
                    ...insertData,
                    utility: value[0],
                    unit: value[1].substr(3),
                    unitId: value[1],
                  })
                }}
                style={{ width: '100%' }}
              />
            </td>
            <TableTD>Year :</TableTD>
            <td style={{ minWidth: '100px' }}>
              <Select
                onChange={year => setInsertData({ ...insertData, year })}
                value={insertData.year}
                style={{ width: '100%' }}
              >
                {R.range(curYear - 10, curYear + 3)
                  .reverse()
                  .map(y => (
                    <Select.Option value={y} key={y}>
                      {y}
                    </Select.Option>
                  ))}
              </Select>
            </td>
            <TableTD>Month :</TableTD>
            <td style={{ minWidth: '100px' }}>
              <Select
                onChange={month => setInsertData({ ...insertData, month })}
                value={insertData.month}
                style={{ width: '100%' }}
              >
                {months.map((m, i) => (
                  <Select.Option value={i + 1} key={i + 1}>
                    {m}
                  </Select.Option>
                ))}
              </Select>
            </td>
          </tr>
          <tr>
            <TableTD>Att Starts :</TableTD>
            <td style={{ minWidth: '150px' }}>
              <InputNumber
                value={insertData.attStarts}
                onChange={attStarts =>
                  setInsertData({ ...insertData, attStarts })
                }
                style={{ width: '100%' }}
              />
            </td>
            <TableTD>Succ Starts :</TableTD>
            <td style={{ minWidth: '150px' }}>
              <InputNumber
                value={insertData.succStarts}
                onChange={succStarts =>
                  setInsertData({ ...insertData, succStarts })
                }
                style={{ width: '100%' }}
              />
            </td>

            <TableTD>All T1 T2 :</TableTD>
            <td style={{ minWidth: '150px' }}>
              <InputNumber
                value={insertData.allT1T2}
                onChange={allT1T2 => setInsertData({ ...insertData, allT1T2 })}
                style={{ width: '100%' }}
              />
            </td>

            <TableTD>Hour24 T1 T2 :</TableTD>
            <td style={{ minWidth: '150px' }}>
              <InputNumber
                style={{ width: '100%' }}
                value={insertData.hour24T1T2}
                onChange={hour24T1T2 =>
                  setInsertData({ ...insertData, hour24T1T2 })
                }
              />
            </td>
            <td>
              <Button type="primary" onClick={() => onAdd(true)}>
                Add
              </Button>
            </td>
            <td>
              <Button type="primary" onClick={() => onAdd(false)}>
                Add & Hide
              </Button>
            </td>
            <td>
              <Button type="danger" onClick={onCancel}>
                Cancel
              </Button>
            </td>
          </tr>
        </tbody>
      </table>
    )
  }

  const headerWithFormatter = headers.map(header =>
    header.ident === 'utility'
      ? {
          ...header,
          // ...toSelectionColProps(utilityNameMap),
          dataFormatter: ({ value }) => utilityNameMap[value] || value,
          sortIndexGetter: ({ rowData }) =>
            utilityNameMap[rowData.utility] || rowData.utility,
        }
      : header.ident === 'unitId'
      ? {
          ...header,
          // choices: [],
          dataFormatter: ({ value }) => unitNameMap[value] || value,
          sortIndexGetter: ({ rowData }) =>
            unitNameMap[rowData.unit] || rowData.unit,
        }
      : header
  )
  return [
    <CommonScreen
      isAdminScreen={false}
      title={title}
      header={headerWithFormatter}
      saveTask={modifyTask}
      retrieveTask={retrieveTask}
      deleteTask={deleteTask}
      altBy={d => d.month}
      autoRetrieve
      sortOptions={headers}
      widthOffset={100}
      insertComp={writePermision && insertEvent && insertComp}
      insertCompHeight={90}
      onInsertEvent={b => setInsertEvent(b)}
      withoutModify={!writePermision}
      allowInsert={writePermision}
    />,
  ]
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
  actionPermits: getPermitActions(state),
  envConfig: getEnvConfig(state),
})
export default connect(mapStateToProps)(PerfOverided)
